var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInclusion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#E00E62"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1806_3699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4785 19.625C36.3395 19.625 33.5535 20.8641 31.666 22.9937C29.7785 20.8641 26.9926 19.625 23.8535 19.625C21.1195 19.6283 18.4984 20.7159 16.5651 22.6491C14.6319 24.5824 13.5443 27.2035 13.541 29.9375C13.541 41.2406 30.0738 50.2719 30.777 50.6516C31.0502 50.7987 31.3557 50.8757 31.666 50.8757C31.9764 50.8757 32.2818 50.7987 32.5551 50.6516C33.2582 50.2719 49.791 41.2406 49.791 29.9375C49.7877 27.2035 48.7002 24.5824 46.7669 22.6491C44.8336 20.7159 42.2125 19.6283 39.4785 19.625ZM38.6207 41.8687C36.4446 43.7154 34.1183 45.3774 31.666 46.8375C29.2138 45.3774 26.8875 43.7154 24.7113 41.8687C21.3254 38.9641 17.291 34.5344 17.291 29.9375C17.291 28.197 17.9824 26.5278 19.2131 25.2971C20.4438 24.0664 22.113 23.375 23.8535 23.375C26.6348 23.375 28.9629 24.8437 29.9301 27.2094C30.0709 27.5542 30.3111 27.8493 30.6203 28.0571C30.9295 28.2648 31.2935 28.3758 31.666 28.3758C32.0385 28.3758 32.4025 28.2648 32.7117 28.0571C33.0209 27.8493 33.2612 27.5542 33.402 27.2094C34.3691 24.8437 36.6973 23.375 39.4785 23.375C41.219 23.375 42.8882 24.0664 44.1189 25.2971C45.3496 26.5278 46.041 28.197 46.041 29.9375C46.041 34.5344 42.0066 38.9641 38.6207 41.8687Z",
    fill: "#FFF5EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1806_3699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 37,
    fill: "white",
    transform: "translate(11.333 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInclusion);
export default __webpack_public_path__ + "static/media/icon-inclusion.925c56a4be3709713756982a7a0f9fc6.svg";
export { ForwardRef as ReactComponent };